import { getAccount, saveAccount, saveNodeList } from '@/utils/appcache.js'
import { sendErrorLog } from '@/utils/common.js'
import { bindWalletAccount } from '@/service/http.js'
import {
    getAddress,
    oepnWalletWithCredentials,
    importAccountWithMnemonic,
    createDefaultWallet,
    createMultiWallet,
    joinMultiWallet,
    updateAccountStatus,
    startScan
} from '@/wallet/walletUtil.js'

import store from '@/store'

const state = {
    isScaning: false,
    isUpdateTxing: null,
    account: {},
    client: {}
}

const mutations = {
    SET_ACCOUNT(state, val) {
        state.account = val
    },
    SET_SCAN_STATU(state, val) {
        state.isScaning = val
    },
    SET_UPDATE_TX(state, val) {
        state.isUpdateTxing = val
    },
    SET_CLIENT(state, val) {
        state.client = val
    }
}

const actions = {
    /**
   * 退出清理缓存
   */
    clearOut({ commit }) {
        // store.dispatch('node/remove')
        if (store.state.wallet.client) {
            store.state.wallet.client.dispose(() => {
                console.log('退出')
            })
        }
        commit('SET_ACCOUNT', '')
        commit('SET_CLIENT', '')
    },

    /**
   * 删除钱包
   */
    removeAccount({ commit }) {
    // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {
            if (store.state.wallet.client) {
                store.state.wallet.client.dispose(() => {
                    console.log('退出')
                })
            }
            commit('SET_ACCOUNT', '')
            commit('SET_CLIENT', '')
            saveAccount('')
            saveNodeList('')
            console.log('删除完')
            return resolve()
        })
    },

    /**
   * 创建全局client，用于连接服务端
   */
    loadClient({ commit }) {
        return new Promise((resolve, reject) => {
            const currentAccount = store.state.wallet.account
            if (!currentAccount) {
                console.log('未找到账户信息,无法创建client')
                return reject('No using wallet fund')
            }
            const client = oepnWalletWithCredentials(currentAccount)
            client.openWallet(err => {
                if (err) {
                    console.log('error: ', err)
                    return reject(err)
                }
                commit('SET_CLIENT', client)
                return resolve(client)
            })
        })
    },
    /**
   * 加入到多签钱包
   */
    // eslint-disable-next-line no-unused-vars
    joinMultiAccount({ commit }, credentials) {
        return new Promise((resolve, reject) => {
            const name = credentials.walletName ? credentials.walletName : '我的钱包'
            const secret = credentials.multiSecret
            if (!secret) {
                return reject('多签secret不能为空')
            }
            joinMultiWallet(secret, name, credentials)
                .then(res => {
                    res.lastScan = new Date()
                    res.walletName = credentials.walletName
                    if (saveAccount(res)) {
                        store.dispatch('wallet/loadAccount').then(() => {
                            return resolve(true)
                        }).catch(e => {
                            sendErrorLog('[wallet.js-wallet/loadAccount]' + e)
                            return reject(e)
                        })
                    } else {
                        return reject('保存钱包失败')
                    }
                })
                .catch(e => {
                    const errmsg = JSON.stringify(e)
                    sendErrorLog('[wallet.js-joinMultiWallet]' + errmsg)
                    if (errmsg && errmsg.indexOf('Wallet full') >= 0) {
                        return reject('钱包成员已经满额，无法加入')
                    } else {
                        return reject(e)
                    }

                })
        })
    },

    /**
   * 创建一个多签钱包
   */
    // eslint-disable-next-line no-unused-vars
    createMultiAccount({ commit }, credentials) {
        return new Promise((resolve, reject) => {
            const name = credentials.walletName ? credentials.walletName : '我的钱包'
            createMultiWallet(name, credentials, credentials.mm, credentials.mn)
                .then(res => {
                    res.lastScan = new Date()
                    res.walletName = credentials.walletName
                    res.virclePassword = credentials.virclePassword
                    if (saveAccount(res)) {
                        store.dispatch('wallet/loadAccount').then(() => {
                            return resolve(true)
                        }).catch(e => {
                          sendErrorLog('[wallet.js-wallet/loadAccount]' + e)
                            return reject(e)
                        })
                    } else {
                        return reject('保存钱包失败')
                    }
                })
                .catch(e => {
                    const errmsg = JSON.stringify(e)
                    sendErrorLog('[wallet.js-createMultiWallet]' + errmsg)
                    if (
                        errmsg &&
            errmsg.indexOf('Copayer ID already registered on server') >= 0
                    ) {
                        credentials.lastScan = false
                        const saveOk = saveAccount(credentials)
                        if (saveOk) {
                            store.dispatch('wallet/loadAccount').then(() => {
                                return resolve(true)
                            }).catch(e => {
                                sendErrorLog('[wallet.js-wallet/loadAccount]' + e)
                                return reject(e)
                            })
                        } else {
                            return reject(e)
                        }
                    } else {
                        return reject(e)
                    }
                })
        })
    },

    /**
   * 创建一个新的标准钱包
   */
    // eslint-disable-next-line no-unused-vars
    createNewAccount({ commit }, credentials) {
        return new Promise((resolve, reject) => {
            const name = credentials.walletName ? credentials.walletName : '我的钱包'
            createDefaultWallet(name, credentials)
                .then(res => {
                    res.lastScan = false
                    res.walletName = credentials.walletName
                    res.virclePassword = credentials.virclePassword
                    if (saveAccount(res)) {
                        store.dispatch('wallet/loadAccount').then(() => {
                            return resolve(res)
                        }).catch(e => {
                            sendErrorLog('[wallet.js-wallet/loadAccount]' + e)
                            return reject(e)
                        })
                    } else {
                        return reject('保存钱包失败')
                    }
                })
                .catch(e => {
                    const errmsg = JSON.stringify(e)
                    if ( errmsg && errmsg.indexOf('Copayer ID already registered on server') >= 0 ) {
                        credentials.lastScan = false
                        const saveOk = saveAccount(credentials)
                        if (saveOk) {
                            store.dispatch('wallet/loadAccount').then(() => {
                                return resolve(credentials)
                            }).catch(e => {
                                sendErrorLog('[wallet.js-wallet/loadAccount]' + e)
                                return reject(e)
                            })
                        } else {
                          sendErrorLog('[wallet.js-saveAccount]' + saveOk)
                          return reject(e)
                        }
                    } else {
                        sendErrorLog('[wallet.js-createDefaultWallet]' + e)
                        return reject(e)
                    }
                })
        })
    },
    /**
   * 助记词导入
   */
    // eslint-disable-next-line no-unused-vars
    importAccountWithMnemonic({ commit }, credentials) {
        return new Promise((resolve, reject) => {
            importAccountWithMnemonic(credentials)
                .then(res => {
                    res.lastScan = false
                    res.walletName = credentials.walletName
                    res.virclePassword = credentials.virclePassword
                    if (saveAccount(res)) {
                        store.dispatch('wallet/loadAccount').then(() => {
                            return resolve(res)
                        }).catch(e => {
                            sendErrorLog('[wallet.js-wallet/loadAccount]' + e)
                            return reject(e)
                        })
                    } else {
                        return reject('保存钱包失败')
                    }
                })
                .catch(err => {
                    sendErrorLog('[wallet.js-importAccountWithMnemonic]' + err)
                    return reject(err)
                })
        })
    },
    /**
   * 绑定钱包地址到服务端
   */
    // eslint-disable-next-line no-unused-vars
    bindAddress({ commit }) {
        return new Promise((resolve, reject) => {
            const currentAccount = store.state.wallet.account
            if (!currentAccount) {
                console.log('未找到账户信息,无法创建client')
                return reject('No using wallet fund')
            }
            getAddress(currentAccount, false)
                .then(address => {
                    const param = {
                        userId: store.state.user.id,
                        account: address
                    }
                    bindWalletAccount(param).then(ures => {
                        console.log(ures)
                        if (ures.code == 200) {
                            return resolve(true)
                        } else {
                            return reject(ures.pagePrompt)
                        }
                    })
                }).catch(e => {
                  sendErrorLog('[wallet.js-getAddress]' + e)
                })
        })
    },
    /**
   * 加载钱包信息到store
   */
    loadAccount({ commit }) {
        return new Promise((resolve, reject) => {
            getAccount().then(account => {
                if (account) {
                    commit('SET_ACCOUNT', account)
                } else {
                    commit('SET_ACCOUNT', null)
                }
                return resolve(account)
            }).catch(e => {
                sendErrorLog('[wallet.js-getAccount]' + e)
                return reject(e)
            })
        })
    },

    /**
   * 手动更新钱包状态
   */
    // eslint-disable-next-line no-unused-vars
    updateAccountCache({ commit }) {
        return new Promise((resolve, reject) => {
            getAccount().then(account => {
                if (!account) {
                    return reject(false)
                }

                updateAccountStatus(account)
                    .then(res => {
                        store.dispatch('wallet/loadAccount').then(() => {
                            return resolve(res)
                        }).catch(e => {
                            return reject(e)
                        })
                    })
                    .catch(err => {
                        sendErrorLog('[wallet.js-wallet/loadAccount]' + err)
                        return reject(err)
                    })
            })
        })
    },
    /**
   * 更新扫描状态
   */
    // eslint-disable-next-line no-unused-vars
    updateTxInitStatus({ commit }, txinitStatus) {
        const walletNow = store.state.wallet.account
        walletNow.isTxInit = txinitStatus
        saveAccount(walletNow)
        store.dispatch('wallet/loadAccount')
    },
    /**
   * 更新扫描状态
   */
    updateScanStatus({ commit }, scanstatus) {
        const walletNow = store.state.wallet.account
        walletNow.lastScan = scanstatus
        commit('SET_SCAN_STATU', false)
        saveAccount(walletNow)
    },
    /**
   * 扫描钱包
   */
    walletScan({ commit }) {
        const isscaning = store.state.wallet.isScaning
        if (isscaning) {
            return
        }
        const walletNow = store.state.wallet.account
        if (
            walletNow.cacheStatus &&
      walletNow.cacheStatus.wallet &&
      walletNow.cacheStatus.wallet.n > 1 &&
      walletNow.cacheStatus.wallet.beRegistered == false
        ) {
            console.warn('多签钱包未完成，无法扫描')
            return
        }
        if (walletNow.cacheStatus && walletNow.cacheStatus.wallet && walletNow.cacheStatus.wallet.singleAddress) {
            console.warn('单签钱包无需扫描')
            return
        }
        commit('SET_SCAN_STATU', true)
        console.log('扫描开始...')
        startScan()
            .then(() => {
                console.log('完成扫描申请')
            })
            .catch(e => {
                sendErrorLog('[wallet.js-startScan]' + e)
                console.log(e)
            })
    }
}

export default {
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/wallet.js